module.exports = __webpack_public_path__ + "assets/img/s1_tab2.ba6d6e84.png";